"use client";

import { FC, useState } from "react";
import clsx from "clsx";
import { useScopedI18n } from "@/i18n/client";
import { StoreRegion } from "@/lib/builder/builder.config";
import NewsCard from "../NewsCard/NewsCard";
import Pagination from "@/components/UI/Pagination/Pagination";
import styles from "./LatestNews.module.scss";
import { ArticleEntryType } from "@/lib/builder/server-quries";

interface Props {
	articles: any[];
	tags: string[] | undefined;
	store: StoreRegion;
	lang: string;
	title: ArticleEntryType;
}

const PAGE_SIZE = 9;

const LatestNews: FC<Props> = ({ articles, tags, store, lang, title }) => {
	const pageCount = Math.ceil(articles.length / PAGE_SIZE);

	const [activePage, setActivePage] = useState(0);

	const scopedT = useScopedI18n("blog");

	const getPage = (page: number) => {
		const foundPage = articles.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
		return foundPage;
	};

	return (
		<div
			className={clsx([styles.container, tags !== undefined && styles.hasTags])}
		>
			{!tags && (
				<h2 className={styles.title}>
					{title === "news" ? scopedT("latestNews") : scopedT("latestBlogs")}
				</h2>
			)}
			{tags && (
				<h2 className={styles.title}>
					{scopedT("tag")}: {tags.join(", ")}
				</h2>
			)}
			<div className={styles.grid}>
				{getPage(activePage)?.map((article) => (
					<NewsCard
						key={article.id}
						title={article.data.title}
						link={
							store !== "global"
								? `/${store}/${lang}/${article.data.url}`
								: `${article.data.url}`
						}
						date={article.data.date}
						image={article.data.featuredImage ?? ""}
						precis={article.data.description}
					/>
				))}
			</div>
			<Pagination
				pageCount={pageCount}
				page={activePage}
				onPageChange={setActivePage}
			/>
		</div>
	);
};

export default LatestNews;
